import { useFounderFinance } from "../hooks/useFounderFinance";
import { FounderFinanceView } from "./FounderFinanceView";

export default function FounderFinance() {
  const { data, error, isLoading, refresh, saveCost, saveError, savingCostId } = useFounderFinance();

  return (
    <FounderFinanceView
      data={data}
      error={error}
      isLoading={isLoading}
      onRefresh={() => void refresh()}
      onSaveCost={(input) => void saveCost(input)}
      saveError={saveError}
      savingCostId={savingCostId}
    />
  );
}
